import Vue from 'vue'
import Router from 'vue-router'
import foot from '@/components/public/foot'
import head from '@/components/public/head'
import main from '@/components/public/main'
import index from '@/components/index'
import product from '@/components/product'
import product_list from '@/components/product_list'
import product_list2 from '@/components/product_list2'
import product_detail from '@/components/product_detail'
import our from '@/components/our'
import aboutUs from '@/components/about_us'
import core from '@/components/core'
import news from '@/components/news'
import news_detail from '@/components/news_detail'
import cases from '@/components/cases'
import cases_detail from '@/components/cases_detail'
import brand from '@/components/brand'
import brand_detail from '@/components/brand_detail'
import contact from '@/components/contact'
import leavemsg from '@/components/leavemsg'
import customer_s from '@/components/customer_s'
import search from '@/components/search'
import active_detail from '@/components/active_detail'


import m_foot from '@/components/mobile/public/foot'
import m_head from '@/components/mobile/public/head'
import m_main from '@/components/mobile/public/main'
import m_p_main from '@/components/mobile/public/p_main'
import m_index from '@/components/mobile/index'
import m_product from '@/components/mobile/product'
import m_product_list from '@/components/mobile/product_list'
import m_product_detail from '@/components/mobile/product_detail'
import m_our from '@/components/mobile/our'
import m_aboutUs from '@/components/mobile/about_us'
import m_core from '@/components/mobile/core'
import m_news from '@/components/mobile/news'
import m_news_detail from '@/components/mobile/news_detail'

import detail from '@/components/mobile/detail'
import m_cases from '@/components/mobile/cases'
import m_cases_detail from '@/components/mobile/cases_detail'
import m_brand from '@/components/mobile/brand'
import m_contact from '@/components/mobile/contact'
import m_customer_s from '@/components/mobile/customer_s'
import m_leavemsg from '@/components/mobile/leavemsg'
import m_search from '@/components/mobile/search'
import m_active_detail from '@/components/mobile/active_detail'
/*import list from '@/components/list'*/
Vue.use(Router)

export default new Router({ 
  routes: [
    {
      path: '/m',
      name: 'mindex',
      component: m_p_main,
      children:[
        {
          path: '',
          name: 'm_index',
          redirect: to => {
            // 方法接收 目标路由 作为参数
            // return 重定向的 字符串路径/路径对象
            return '/index'
          },
          components: {
            default:m_index,
            head:m_head,
            foot:m_foot
          }
        },        
        {
          path: 'product',
          name: 'm_product',
          components: {
            default:m_product,
            /*head:m_head,*/
            foot:m_foot
          }
        },
      ]
    },
    {
      path: '/m',
      name: 'mindex',
      component: m_main,
      children:[
        {
          path: '',
          name: 'm_index',
          components: {
            default:m_index,
            head:m_head,
            foot:m_foot
          }
        },
        {
          path: 'index',
          name: 'm_index',
          components: {
            default:m_index,
            head:m_head,
            foot:m_foot
          }
        },

        {
          path: 'product/list/:ids',
          name: 'm_product_list',
          components: {
            default:m_product_list,
            /*head:m_head,*/
            foot:m_foot
          }
        },
        {
          path: 'product/detail/:ids',
          name: 'm_product_detail',
          components: {
            default:m_product_detail,
            /*head:m_head,*/
            foot:m_foot
          }
        },
        {
          path: 'our',
          name: 'm_our',
          components: {
            default:m_our,
            head:m_head,
            foot:m_foot
          }
        },
        {
          path: 'our/aboutUs',
          name: 'm_our',
          components: {
            default:m_aboutUs,
            head:m_head,
            foot:m_foot
          }
        },
        {
          path: 'our/core',
          name: 'm_core',
          components: {
            default:m_core,
            head:m_head,
            foot:m_foot
          }
        },
        {
          path: 'our/news',
          name: 'm_news',
          components: {
            default:m_news,
            head:m_head,
            foot:m_foot
          }
        },
        {
          path: 'our/news/detail/:id',
          name: 'm_news_detail',
          components: {
            default:m_news_detail,
            head:m_head,
            foot:m_foot
          }
        },
        {
          path: 'our/cases/:id',
          name: 'm_cases',
          components: {
            default:m_cases,
            head:m_head,
            foot:m_foot
          }
        },
        {
          path: 'our/cases/detail/:id',
          name: 'm_cases_detail',
          components: {
            default:m_cases_detail,
            head:m_head,
            foot:m_foot
          }
        },
        {
          path: 'our/brand/:id',
          name: 'm_brand',
          components: {
            default:m_brand,
            head:m_head,
            foot:m_foot
          }
        },
        {
          path: 'our/brand/detail/:id',
          name: 'm_brand',
          components: {
            default:m_news_detail,
            head:m_head,
            foot:m_foot
          }
        },
        {
          path: 'our/contact',
          name: 'm_brand',
          components: {
            default:m_contact,
            head:m_head,
            foot:m_foot
          }
        },
        {
          path: 'our/customer_s/:id',
          name: 'customer_s',
          components: {
            default:m_customer_s,
            head:m_head,
            foot:m_foot
          }
        },
        {
          path: 'leavemsg',
          name: 'm_leavemsg',
          components: {
            default:m_leavemsg,
            head:m_head,
            foot:m_foot
          }
        },
        {
          path: 'search/:id',
          name: 'm_search',
          components: {
            default:m_search,
            head:m_head,
            foot:m_foot
          }
        },
        {
          path: 'active/detail',
          name: 'm_active_detail',
          components: {
            default:m_active_detail,
            head:m_head,
            foot:m_foot
          }
        },
      ]
    },
    {
      path: '/',
      name: 'index',
      component: main,
      children:[
        {
          path: '',
          name: 'index',
          components: {
            default:index,
            head:head,
            foot:foot
          }
        },
        {
          path: 'index',
          name: 'index',
          components: {
            default:index,
            head:head,
            foot:foot
          }
        },
        {
          path: 'product',
          name: 'product',
          components: {
            default:product,
            head:head,
            foot:foot
          }
        },
        {
          path: 'product/list/:id',
          name: 'product_list',
          components: {
            default:product_list,
            head:head,
            foot:foot
          }
        },
        {
          path: 'product/list2/:id',
          name: 'product_list2',
          components: {
            default:product_list2,
            head:head,
            foot:foot
          }
        },
        {
          path: 'product/detail/:id',
          name: 'product_detail',
          components: {
            default:product_detail,
            head:head,
            foot:foot
          }
        },
        {
          path: 'active/detail',
          name: 'active_detail',
          components: {
            default:active_detail,
            head:head,
            foot:foot
          }
        },
        {
          path: 'our',
          name: 'our',
          components: {
            default:our,
            head:head,
            foot:foot
          }
        },
        {
          path: 'our/aboutUs',
          name: 'aboutUs',
          components: {
            default:aboutUs,
            head:head,
            foot:foot
          }
        },
        {
          path: 'our/core',
          name: 'core',
          components: {
            default:core,
            head:head,
            foot:foot
          }
        },
        {
          path: 'our/news',
          name: 'news',
          components: {
            default:news,
            head:head,
            foot:foot
          }
        },
        {
          path: 'our/news/detail/:id',
          name: 'news_detail',
          components: {
            default:news_detail,
            head:head,
            foot:foot
          }
        },
        {
          path: 'our/cases/:id',
          name: 'cases',
          components: {
            default:cases,
            head:head,
            foot:foot
          }
        },
        {
          path: 'our/cases/detail/:id',
          name: 'cases_detail',
          components: {
            default:cases_detail,
            head:head,
            foot:foot 
          }
        },
        {
          path: 'our/brand/:id',
          name: 'brand',
          components: {
            default:brand,
            head:head,
            foot:foot
          }
        },
        {
          path: 'our/brand/detail/:id',
          name: 'brand',
          components: {
            default:brand_detail,
            head:head,
            foot:foot
          }
        },
        {
          path: 'our/contact',
          name: 'contact',
          components: {
            default:contact,
            head:head,
            foot:foot
          }
        },
        {
          path: 'leavemsg',
          name: 'leavemsg',
          components: {
            default:leavemsg,
            head:head,
            foot:foot
          }
        },
        {
          path: '/our/customer_s/:id',
          name: 'customer_s',
          components: {
            default:customer_s,
            head:head,
            foot:foot
          }
        },
        {
          path: '/search/:id',
          name: 'search',
          components: {
            default:search,
            head:head,
            foot:foot
          }
        },
      ]
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js